import { FC, ReactNode } from 'react';

interface DashboardTileProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  wide?: boolean;
  'data-testid'?: string;
  'data-tour'?: string;
}

const DashboardTile: FC<DashboardTileProps> = ({
  children,
  className = '',
  onClick,
  wide,
  'data-testid': testId,
  'data-tour': dataTour,
}) => {
  return (
    <div
      data-testid={testId}
      data-tour={dataTour}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}
      className={`
        relative rounded-[14px] p-5 transition-all duration-300 overflow-hidden
        ${onClick ? 'cursor-pointer' : ''}
        ${wide ? 'col-span-1 md:col-span-2' : ''}
        ${className}
      `}
      style={{
        background: 'var(--tile-bg)',
        border: '0.5px solid var(--tile-border)',
      }}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.border = '0.5px solid var(--tile-border-hover)';
        el.style.transform = 'translateY(-3px)';
        el.style.boxShadow = `0 8px 24px var(--tile-shadow)`;
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.border = '0.5px solid var(--tile-border)';
        el.style.transform = 'translateY(0)';
        el.style.boxShadow = 'none';
      }}
    >
      {children}
      {/* Glow effect on hover — handled via CSS transition above */}
    </div>
  );
};

export default DashboardTile;
